import { useCallback, useEffect, useState } from 'react';

import API from '../../api';
import FetchInstance from '../../api/FetchInstance';

export const useApiAuth = (): string | null => {
    const [authToken, setAuthToken] = useState<string | null>(null);

    const loginToApi = useCallback(async () => {
        try {
            const data = await API.auth.loginToApi('efed', 'pass123');
            FetchInstance.setAuthToken(data.token);
            setAuthToken(data.token);
        } catch (error) {
            console.error(error);
        }
    }, []);

    useEffect(() => {
        loginToApi();
    }, [loginToApi]);

    return authToken;
};
